export default {"src":"/_next/static/media/brazilnuts.54605623.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};